import { FormAddonQuantities } from '@/features/pos/components/ProductConfigurationModal/form/types'
import { calcAddonsTotalQuantity } from '@/features/pos/components/ProductConfigurationModal/utils/calcAddonsTotalQuantity'
import { Map } from 'immutable'

class AddonQuantitiesAdjuster {
    getNextRepeatableAddonQuantities(
        currentQuantities: FormAddonQuantities,
        groupMaxQuantity: number | null,
        addonId: string,
        nextQuantity: number
    ): FormAddonQuantities {
        return this.getNextAddonQuantities(
            currentQuantities,
            groupMaxQuantity,
            addonId,
            nextQuantity
        )
    }

    getNextNonRepeatableAddonQuantities(
        currentQuantities: FormAddonQuantities,
        groupMaxQuantity: number | null,
        addonId: string
    ): FormAddonQuantities {
        return this.getNextAddonQuantities(currentQuantities, groupMaxQuantity, addonId)
    }

    private getNextAddonQuantities(
        currentQuantities: FormAddonQuantities,
        groupMaxQuantity: number | null,
        addonId: string,
        targetQuantity?: number
    ): FormAddonQuantities {
        let quantitiesMap = this.toImmutableQuantitiesMap(currentQuantities ?? {})

        let nextQuantity

        if (targetQuantity === undefined) {
            nextQuantity = quantitiesMap.has(addonId) ? 0 : 1
        } else {
            nextQuantity = targetQuantity
        }

        const isDelete = nextQuantity === 0

        if (isDelete) return this.deleteAddon(quantitiesMap, addonId)

        if (groupMaxQuantity === 1) quantitiesMap = quantitiesMap.clear()

        const updatedQuantities = this.updateQuantities(quantitiesMap, addonId, nextQuantity)

        if (this.exceedsMaxQuantity(groupMaxQuantity, updatedQuantities)) return currentQuantities

        return updatedQuantities
    }

    private toImmutableQuantitiesMap = (
        currentQuantities: FormAddonQuantities
    ): Map<string, number> => {
        return Map(currentQuantities)
    }

    private updateQuantities = (
        quantitiesMap: Map<string, number>,
        addonId: string,
        nextQuantity: number
    ): FormAddonQuantities => {
        return quantitiesMap.set(addonId, nextQuantity).toJS()
    }

    private deleteAddon = (
        quantitiesMap: Map<string, number>,
        addonId: string
    ): FormAddonQuantities => {
        const newQuantitiesMap = quantitiesMap.delete(addonId)

        return newQuantitiesMap.toJS()
    }

    private exceedsMaxQuantity = (
        groupMaxQuantity: number | null,
        addonQuantities: FormAddonQuantities
    ): boolean => {
        return (
            groupMaxQuantity !== null && calcAddonsTotalQuantity(addonQuantities) > groupMaxQuantity
        )
    }
}

export default new AddonQuantitiesAdjuster()
